import { gql } from 'graphql-tag';
import { SirFragment } from '../fragments';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetSirsData } from '../types';

export const GET_SIRS: TypedDocumentNode<IGetSirsData> = gql`
  query getSirs {
    viewer {
      id
      site {
        id
        sirs {
          ...SirFragment
        }
      }
    }
  }
  ${SirFragment}
`;
